import styled from 'styled-components';

import { CFG, CFG_CHROME } from '../../../../../theme/configurator-tokens';

/** Rounded panel used for the "Themes" and "Color & styling" blocks. */
export const Pane = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
  border-radius: 16px;
  padding: 16px 8px 8px;
  background: ${CFG_CHROME.cardBg};
`;

/** Small pill button ("See all", "Browse N themes"). */
export const ChipButton = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
  border: none;
  border-radius: 9999px;
  background: ${CFG_CHROME.chipBg};
  padding: 6px 12px;
  font-size: 14px;
  line-height: 16px;
  color: ${CFG.base200};
  transition: background-color ${'150ms'} ease;

  &:hover {
    background: ${CFG_CHROME.chipHover};
  }
`;

/** Hairline divider with a soft gradient, matching the Figma line fill. */
export const Line = styled.div`
  height: 1px;
  width: 100%;
  background: linear-gradient(to right, transparent, ${CFG_CHROME.dividerVia}, transparent);
`;
